import { useRef, useState, useEffect, useContext } from 'react';
import axios from '../../axios/Axios.js';
import React from 'react';
import AuthContext from "../../context/AuthProvider";
import styles from './Forgot.module.scss';
import {BrowserView, MobileView} from 'react-device-detect';
import AlertMessage from "../../components/Alert";
import { isAuthenticated, login } from "../../services/auth";
import {
  Link,
  useNavigate,
} from "react-router-dom";
import { useSnackbar } from 'notistack';

function validPassword(password) {
  return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=]).{8,}$/.test(password);
}

function Forgot(props) {
  const [counter, setCounter] = React.useState(60);
  const [input, setInput] = useState({
    username: '',
    password: '',
    confirmPassword: '',
    confirmation_code: ''
  });
 
  const [error, setError] = useState({
    username: '',
    password: '',
    confirmPassword: '',
    confirmation_code: ''
  })

  const onInputChange = e => {
    const { name, value } = e.target;
    
    if (name === "confirmation_code"){
      if(value.length > 6){
        return
      }
    }

    setInput(prev => ({
      ...prev,
      [name]: value
    }));

    validateInput(e);
  }
 
  const validateInput = e => {
    let { name, value } = e.target;
    setError(prev => {
      const stateObj = { ...prev, [name]: "" };
   
      switch (name) {
        case "confirmation_code":
          if (value.length !== 6) {
            stateObj[name] = "Invalid code.";
          }
          break;

        case "username":
          if (!value) {
            stateObj[name] = "Please enter e-mail.";
          } else if (!value.endsWith("@valcann.com.br")){
            stateObj[name] = "Invalid e-mail";
          }
          break;
   
        case "password":
          if (!value) {
            stateObj[name] = "Please enter Password.";
          } else if (!validPassword(value)){
            stateObj[name] = "Minimun of 8 characters. Use a combination of uppercase, lowercase, numbers and symbols.";
          } else if (input.confirmPassword && value !== input.confirmPassword) {
            stateObj["confirmPassword"] = "Password and Confirm Password does not match.";
          } else {
            stateObj["confirmPassword"] = input.confirmPassword ? "" : error.confirmPassword;
          }
          break;
        case "confirmPassword":
          if (!value) {
            stateObj[name] = "Please enter Confirm Password.";
          } else if (input.password && value !== input.password) {
            stateObj[name] = "Password and Confirm Password does not match.";
          }
          break;
        default:
          break;
      }
   
      return stateObj;
    });
  }

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  useEffect(() => {
    document.title = 'Recuperar senha';
  }, []);

  React.useEffect(() => {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
  }, [counter]);

  const navigate = useNavigate();
  const { setAuth } = useContext(AuthContext);

  const userRef = useRef();
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(0);

  const sendChangePassword = async (e) => {
    setLoading(true);
    e.preventDefault();
    const response = await axios.post(
        "/password/confirm",
        JSON.stringify({ "username": input.username, "password": input.password, "confirmation_code": input.confirmation_code}),
        {
        headers: { "Content-Type": "application/json" },
        }
    ).then( (res) => {
      enqueueSnackbar("Senha alterada com sucesso!", { 
        variant: 'success'
      })
      navigate('/login');
      setLoading(false);
    }).catch(err => {
      setLoading(false)
      if (!err?.response) {
        enqueueSnackbar('Sem resposta do servidor!', { 
          variant: 'error'
        })
      } else if (err.response?.status === 401) {
        if (err.data?.message) {
          enqueueSnackbar(err.data.message, { 
            variant: 'error'
          });
        } else {
          enqueueSnackbar('Não autorizado!', { 
            variant: 'error'
          });
        };
      } else {
        if(!err?.data.message){
          enqueueSnackbar("Error "+ err?.data.message, { 
            variant: 'error'
          })
        }
        else{
          enqueueSnackbar("Error: cheque as informações inseridas!", { 
            variant: 'success'
          })
          setStep(1);
        }
      }
    });
  };

  const sendCode = async (e) => {
    
    setLoading(true);
    e.preventDefault();
    const response = await axios.post(
        "/password/forgot",
        JSON.stringify({ "username": input.username}),
        {
        headers: { "Content-Type": "application/json" },
        }
    ).then( (res) => {
      enqueueSnackbar("Cheque seu e-mail!", { 
        variant: 'success'
      })
      setStep(1);
      setLoading(false);
      setCounter(60);
    }).catch(err => {
      setCounter(60);
      setLoading(false)
      if (!err?.response) {
        enqueueSnackbar('Sem resposta do servidor!', { 
          variant: 'error'
        })
      } else if (err.response?.status === 401) {
        if (err.data?.message) {
          enqueueSnackbar(err.data.message, { 
            variant: 'error'
          });
        } else {
          enqueueSnackbar('Não autorizado!', { 
            variant: 'error'
          });
        };
      } else {
        if(!err?.data.message){
          enqueueSnackbar("Error "+ err?.data.message, { 
            variant: 'error'
          })
        }
        else{
          enqueueSnackbar("Cheque seu e-mail!", { 
            variant: 'success'
          })
          setStep(1);
        }
      }
    });
  };

  return (
  <div className={styles.root}>
    {loading && ( // Mostra o componente de loading se o estado for verdadeiro
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <img className={styles.imgLoading} src={require('../../assets/loading.gif')} />
        </div>
      )}
    <BrowserView className={styles.image1}>
    {<img className={styles.image1} src={require('./assets/611e2e6637a49d2d9861a1258d1edf71.png')} alt="alt text" />}
    </BrowserView>
    <div className={styles.box}>
      <div className={styles.flex_col}>
        <img className={styles.image} src={require('./assets/86d5b68e1096185049130f3b34aab905.png')} alt="alt text" />
        <h5 className={styles.highlight}>Redefinir Senha</h5>
        <span className={styles.sendAgain}>Insira o e-mail utilizado em sua conta, você receberá um código de verificação para redefinir sua senha</span>
          <form className={styles.flex_col1}>
            <label className={styles.box1}>
              <div className={styles.info}>
              E-mail
              </div>
              <input
              disabled={step !== 0}
              className={styles.info1}
              type="text"
              name="username"
              onChange={onInputChange}
              placeholder="Seu e-mail valcann."
              value={input.username}
              id="user"
              required
              />
              {error.username && <span className={styles.err}>{error.username}</span>}
            </label>

            {step >= 1 && (
            <label className={styles.box1}>
              <div className={styles.info}>
              Código
              </div>
              <input
              className={styles.info1}
              type="text"
              name="confirmation_code"
              onChange={onInputChange}
              placeholder="Insira o código recebido"
              value={input.confirmation_code}
              id="confirmation_code"
              required
              />
              {error.confirmation_code && <span className={styles.err}>{error.confirmation_code}</span>}
              {counter > 0 && input.confirmation_code.length !== 6 && (
                <span className={styles.sendAgain}>Enviar novamente em {counter} segundos.</span>
              )}
              {counter === 0 && input.confirmation_code.length !== 6 && (
                <button onClick={sendCode} className={styles.sendAgainButton}>Clique aqui para enviar novamente.</button>
              )}
            </label>
            )}

            {step >= 1 && input.confirmation_code.length === 6 && (
            <label className={styles.box1}>
              <div className={styles.info}>
              Senha
              </div>
              <input
                className={styles.info1}
                type="password" name="password"
                placeholder="Insira sua senha"
                id="password"
                value={input.password}
                onChange={onInputChange}
                onBlur={validateInput}
                required
              />
            {error.password && <span className={styles.err}>{error.password}</span>}
            </label>
            )}
            {step >= 1 && input.confirmation_code.length === 6 && (
            <label className={styles.box1}>
              <div className={styles.info}>
              Confirmar senha
              </div>
              <input
                className={styles.info1}
                type="password" name="confirmPassword"
                placeholder="Confirmar senha"
                value={input.confirmPassword}
                onChange={onInputChange}
                onBlur={validateInput}
                id="confirmPassword"
                required
              />
            {error.confirmPassword && <span className={styles.err}>{error.confirmPassword}</span>}
            </label>
            )}
            {step >= 1 && (
            <button onClick={sendChangePassword} className={styles.info2} disabled={!input.username || error.username || !input.password || error.password || !input.confirmation_code || error.confirmation_code || !input.confirmPassword || error.confirmPassword}>Alterar senha</button>
            )}

          {step === 0 && (
            <button onClick={sendCode} className={styles.info2} disabled={!input.username || error.username}>Enviar código</button>
          )}
          </form>

        

      </div>
    </div>
  </div>
);
}

export default Forgot;
